export default __webpack_public_path__ + "static/media/dot.7c1b47f0.svg";